export function freeTrialLabel(days: number): string {
  return `${days}-day`;
}

export function freeTrialDurationLabel(days: number): string {
  return `${days}-day trial`;
}

export function startFreeTrialAnd(days: number, rest: string): string {
  return `Start a ${days}-day free trial and ${rest}`;
}

export function freeTrialEvaluationPhrase(days: number): string {
  return `${days}-day free trial`;
}

export function freeTrialTrialPhrase(days: number): string {
  return `${days}-day free trial`;
}

export function freeTrialCtaButton(days: number): string {
  return `Try It Free for ${days} Days`;
}

export function freeTrialEvaluationDescription(days: number): string {
  return `Start a ${freeTrialEvaluationPhrase(days)}. No credit card required. Import transactions, build rules, and explore your cash flow.`;
}

export function freeTrialSeoSuffix(days: number): string {
  return `Free ${freeTrialLabel(days)} trial.`;
}

export function freeTrialPricingSeoDescription(days: number): string {
  return `Choose a Where Does My Money Go plan: ${freeTrialLabel(days)} free trial, monthly access, or annual access.`;
}

export function freeTrialFaqAnswer(days: number): string {
  return `Yes, every new account gets a ${freeTrialTrialPhrase(days)} with full access: importing transactions, building rules, cash flow tables, all of it. No credit card needed to start.`;
}

export function freeTrialJsonLdOfferDescription(days: number): string {
  return `${freeTrialLabel(days)} free trial, no credit card required`;
}
